import React from "react";
// import "./serviceDetail.css";
// import ServiceContactForm from "../pages/servicecontactform";
import ContactForm from "../pages/Contact";


export default function FlourMills() {
  return (
    <div className="page-container">

      {/* Hero */}
      <section
        className="hero"
        style={{ backgroundImage: "url('/Gallerypics/952a5315668b4196f0c8e0c970f9d2f9.jpg')" }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">Flour Mills Painting</h1>
      </section>

      {/* Intro */}
      <section className="section">
        <p>
          We provide specialized industrial coatings for flour mills that meet 
          hygiene and safety standards. Our paint solutions resist dust, moisture, 
          and wear, ensuring long-term durability in production environments.
        </p>
      </section>

      {/* Why Choose Us */}
      <section className="section bg-light">
        <h2>Why Choose Us</h2>
        <div className="why-list">
          <div className="why-item">
            <i className="fas fa-shield-alt"></i>
            <p>Food-safe, non-toxic coatings</p>
          </div>
          <div className="why-item">
            <i className="fas fa-industry"></i>
            <p>Durable industrial-grade paints</p>
          </div>
          <div className="why-item">
            <i className="fas fa-broom"></i>
            <p>Easy-to-clean surfaces</p>
          </div>
          <div className="why-item">
            <i className="fas fa-clock"></i>
            <p>Minimal downtime during work</p>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section">
        <h2>Our Process</h2>
        <ol className="process-list">
          <li>Site inspection & preparation</li>
          <li>Dust-proofing & sealing</li>
          <li>Application of food-safe coatings</li>
          <li>Final inspection & handover</li>
        </ol>
      </section>

      {/* Gallery */}
      <section className="section bg-light">
        <h2>Recent Projects</h2>
        <div className="gallery">
          <img src="/Gallerypics/952a5315668b4196f0c8e0c970f9d2f9.jpg" alt="Flour Mill Project 1" />
          <img src="/Project pics/Superior Building.jpg" alt="Flour Mill Project 2" />
          <img src="/Project pics/Lining floor.JPG" alt="Flour Mill Project 3" />
        </div>
      </section>

      {/* Contact Form */}
      <ContactForm/>
    
    </div>
  );
}
